import React, { FC } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import Schedule from "../schedule";
import { useFormikContext } from "formik";

interface ScheduleStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
}

const ScheduleStep: FC<ScheduleStepProps> = ({ onNext, onBack }) => {
    const { translate } = useLocale();
    const { isValid } = useFormikContext<any>();
    
    return (
        <div className="p-5 h-full">
            <div className="overflow-y-auto overflow-x-hidden">
                <Schedule />
            </div>

            <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
                <div className="flex flex-row mt-4">
                    <button
                        className="py-1 px-5 secondary secondary-inverse"
                        type="button"
                        onClick={onBack}>
                        {translate.byKey(TranslationKeys.back)}
                    </button>
                </div>
                <div className="flex flex-row justify-end mt-4 pl-3">
                    <button
                        className={`py-1 px-5 secondary ${isValid ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                        type="button"
                        onClick={isValid ? onNext : () => {}}
                    >
                        {translate.byKey(TranslationKeys.next)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ScheduleStep;
